import type { ReactNode } from "react";

import DocsSidebar from "@/components/docs/DocsSidebar";

const EYEBROW = "text-[10.5px] font-semibold uppercase tracking-[0.14em] text-[#8B93A7]";

const DocsLayout = ({
  current,
  eyebrow,
  title,
  answer,
  children,
}: {
  current: string;
  eyebrow: string;
  title: string;
  answer: string;
  children: ReactNode;
}) => (
  <section className="mx-auto flex w-full max-w-screen-2xl flex-col gap-8 px-4 pb-10 pt-8 md:px-12 md:pt-10 lg:flex-row lg:gap-14 lg:px-[120px]">
    <DocsSidebar current={current} />
    <div className="flex min-w-0 flex-1 flex-col gap-10 lg:max-w-[860px]">
      <header className="flex flex-col gap-4">
        <span className={EYEBROW}>{eyebrow}</span>
        <h1 className="text-balance text-3xl font-semibold tracking-tight text-[#101828] sm:text-4xl lg:text-[44px] lg:leading-[1.08]">
          {title}
        </h1>
        <p className="answer-first text-[16px] leading-[1.7] text-[#525866] sm:text-[17px]">
          {answer}
        </p>
      </header>
      {children}
    </div>
  </section>
);

export default DocsLayout;
